import styled from 'styled-components'

export const StyledLabel = styled.label`
  ${({ color, theme: { colors, font, monoFont } }) => `
    display: inline-block;
    font-size: ${font('sm')};
    font-family: ${monoFont};
    font-weight: 400;
    letter-spacing: 0.06em;
    padding: 0 0 0.4rem;
    text-indent: 0;
    color: ${color ? colors(color) : colors('foreground', 0.45)};
  `}
`

export const Label = ({ children }) => {
  return <StyledLabel>{children}</StyledLabel>
}

export const ColorizedLabel = ({ text, color }) => {
  return <StyledLabel color={color}>{text}</StyledLabel>
}
